import React from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { publicRoutes } from "router/routes"

import { useAuth } from "hooks"
import browserStorageService, { SESSION_CONFIG_KEY } from "services/browserStorage"

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
const PrivateRoute: React.FC = () => {
	const { isLoggedIn, logout } = useAuth()
	const navigate = useNavigate()

	React.useEffect(() => {
		// Token is necessary to call API and get the user account
		// If no token in local storage, logout and redirect to signin
		const tokenIsAvailable = browserStorageService.get(SESSION_CONFIG_KEY)
		if (!tokenIsAvailable) {
			logout()
			navigate(publicRoutes.signin.path)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	if (isLoggedIn) {
		return <Outlet />
	}

	return null
}

export default PrivateRoute
